import { UseQueryResult } from '@tanstack/react-query'
import { ProductEnhancedDynamicShowcase } from 'src/hooks/useDynamicShowcases'
import { ShopWindowDisplayProps } from './types'

export function transformToShopWindowDisplayProps(
  focusShowCaseResult: UseQueryResult<ProductEnhancedDynamicShowcase, unknown>,
  catalogSlug?: string,
): ShopWindowDisplayProps | null {
  try {
    const focusShowcase = focusShowCaseResult.data

    if (!focusShowcase) return null

    return {
      title: focusShowcase.options.title,
      banners: getBanners(focusShowcase),
      shopWindowType: focusShowcase.options.title,
      products: focusShowcase.products,
      isLoading: focusShowCaseResult.isLoading,
      seeAllLink:
        focusShowcase.options.linkSeeAll?.linkType.toUpperCase() === 'WEB' && catalogSlug
          ? {
              url: `/${catalogSlug}${focusShowcase.options.linkSeeAll.url}`,
              type: 'internal',
            }
          : undefined,
    }
  } catch (error) {
    return null
  }
}

function getBanners(
  focusShowcase: ProductEnhancedDynamicShowcase,
): ShopWindowDisplayProps['banners'] | undefined {
  const { bannerMobile, bannerDesktop } = focusShowcase.options

  if (!bannerMobile?.url && !bannerDesktop?.url) return undefined

  const getBanner = (banner?: { url?: string | null; alt?: string | null }) =>
    banner?.url ? { url: banner.url ?? undefined, alt: banner.alt ?? undefined } : undefined

  return {
    mobile: getBanner(bannerMobile ?? undefined),
    desktop: getBanner(bannerDesktop ?? undefined),
  }
}
